import React from 'react';
import { Card, CardContent, Typography, Box, LinearProgress, useMediaQuery, useTheme } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

function SummaryCard({ data }) {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const summaryData = [
    {
      title: 'Monthly Donation',
      value: `₹${data.monthly_donation}`,
      description: 'Total donations this month',
      progress: (parseFloat(data.monthly_donation) / 1000) * 100,
      trend: 'up'
    },
    {
      title: 'Goal Achievement',
      value: `${data.goal_achievement}%`,
      description: 'Of monthly target reached',
      progress: data.goal_achievement,
      trend: data.goal_achievement > 50 ? 'up' : 'down'
    },
    {
      title: 'Active Campaigns',
      value: data.active_campaigns,
      description: 'Currently running',
      progress: (parseInt(data.active_campaigns) / 10) * 100,
      trend: 'up'
    },
    {
      title: 'Volunteer Retention',
      value: `${data.volunteer_retention}`,
      description: 'Active volunteers this month',
      progress: (parseInt(data.volunteer_retention) / 10) * 100,
      trend: 'up'
    }
  ];

  return (
    <Card sx={{ 
      width: isMobile ? '100%' : isTablet ? '100%' : '100%',
      height: isTablet ? 'auto' : '400px',
      paddingBottom: isTablet ? 3 : 5,
      borderRadius: '16px',
      boxShadow: '0 4px 24px rgba(0, 0, 0, 0.1)'
    }}>
      <CardContent sx={{ height: '100%', p: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#00B894', mb: 3 }}>
          Performance Summary
        </Typography>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: 3,
          height: isTablet ? 'auto' : 'calc(100% - 48px)',
          justifyContent: isTablet ? 'flex-start' : 'space-between'
        }}>
          {summaryData.map((item, index) => (
            <Box key={index}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 'medium', color: '#333' }}>
                  {item.title}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  {item.trend === 'up' ? (
                    <TrendingUp sx={{ color: '#00B894', fontSize: 16 }} />
                  ) : (
                    <TrendingDown sx={{ color: '#f44336', fontSize: 16 }} />
                  )}
                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#00B894' }}>
                    {item.value}
                  </Typography>
                </Box>
              </Box>
              <LinearProgress
                variant="determinate"
                value={item.progress > 100 ? 100 : item.progress}
                sx={{
                  height: 8,
                  borderRadius: 4,
                  backgroundColor: '#f0f0f0',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: '#00B894',
                    borderRadius: 4,
                  }
                }}
              />
              <Typography variant="caption" sx={{ color: '#666', mt: 0.5, display: 'block' }}>
                {item.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}

export default SummaryCard;